export default () => ({
  showUpload: false
})



// WEBPACK FOOTER //
// ./src/layout/headers/menu/user/resources/data.js